import Vue from 'vue'
import VueSocketIO from 'vue-socket.io'
import io from 'socket.io-client'

const socketUrl = process.env.VUE_APP_SOCKETS_URL

// Only initialize if endpoint is provided to avoid runtime errors in local envs
let socket = null
if (socketUrl) {
  socket = io(socketUrl, {
    transports: ['websocket'],
    forceNew: true,
  })

  Vue.use(
    new VueSocketIO({
      debug: process.env.NODE_ENV !== 'production',
      connection: socket,
    })
  )
} else if (process.env.NODE_ENV !== 'production') {
  console.warn('VUE_APP_SOCKETS_URL not set, realtime updates disabled.')
}

export { socket }
